module.exports = __webpack_public_path__ + "static/MiasteczkoSlaskie-77d91d4278b3c867557861af9ff506d7.svg";